module.exports = __webpack_public_path__ + "img/doc.b5fadcba.png";